import { DESTINATIONS } from 'constants/config/region'
import type { TrendingDestinationCurated } from 'home/components/TrendingDestinations/constants'
import { escapeRegex } from 'lib/string/regexUtils'

interface DestinationImage {
  name: string
  imageId?: string
}

const destinationNamesById = new Map(
  Object.entries(DESTINATIONS).map(([name, destination]) => [destination.destinationId, name.replaceAll('_', ' ')]),
)

function namesMatch(a: string, b: string): boolean {
  const na = a.trim().toLowerCase()
  const nb = b.trim().toLowerCase()
  if (!na || !nb) return false
  const shorter = na.length <= nb.length ? na : nb
  const longer = na.length > nb.length ? na : nb
  return new RegExp(`\\b${escapeRegex(shorter)}\\b`).test(longer)
}

export function getPopularFlightImages(
  destinations: ReadonlyArray<App.AirportLocation>,
  trending: ReadonlyArray<DestinationImage>,
  curated: ReadonlyArray<TrendingDestinationCurated>,
): Record<string, string | undefined> {
  const curatedEntries = curated.flatMap(destination => {
    const name = destinationNamesById.get(destination.placeId)
    return name && destination.imageId ? [{ name, imageId: destination.imageId }] : []
  })
  const entries = [...trending.filter(destination => destination.imageId), ...curatedEntries]

  return Object.fromEntries(destinations.map(destination => {
    const candidates = [destination.cityDesc, destination.airportName, destination.cityAirportName, destination.country]
    const image = candidates.reduce<string | undefined>((matched, candidate) => (
      matched ?? (candidate ? entries.find(entry => namesMatch(candidate, entry.name))?.imageId : undefined)
    ), undefined)
    return [destination.airportCode, image]
  }))
}
